export var OperationTypeEnum;
(function (OperationTypeEnum) {
    // unknown
    OperationTypeEnum[OperationTypeEnum["unknown"] = 0] = "unknown";
    // register
    OperationTypeEnum[OperationTypeEnum["register"] = 1] = "register";
    // community recovery
    OperationTypeEnum[OperationTypeEnum["communityRecovery"] = 2] = "communityRecovery";
    // add guardian
    OperationTypeEnum[OperationTypeEnum["addGuardian"] = 3] = "addGuardian";
    // delete guardian
    OperationTypeEnum[OperationTypeEnum["deleteGuardian"] = 4] = "deleteGuardian";
    // edit guardian
    OperationTypeEnum[OperationTypeEnum["editGuardian"] = 5] = "editGuardian";
    // remove other manager
    OperationTypeEnum[OperationTypeEnum["removeOtherManager"] = 6] = "removeOtherManager";
    // set login account
    OperationTypeEnum[OperationTypeEnum["setLoginAccount"] = 7] = "setLoginAccount";
    OperationTypeEnum[OperationTypeEnum["managerApprove"] = 8] = "managerApprove";
    OperationTypeEnum[OperationTypeEnum["modifyTransferLimit"] = 9] = "modifyTransferLimit";
    OperationTypeEnum[OperationTypeEnum["transferApprove"] = 10] = "transferApprove";
    OperationTypeEnum[OperationTypeEnum["unsetLoginAccount"] = 11] = "unsetLoginAccount";
    OperationTypeEnum[OperationTypeEnum["setupBackupMailbox"] = 13] = "setupBackupMailbox";
})(OperationTypeEnum || (OperationTypeEnum = {}));
